import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a4fc9632&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a4fc9632&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fc9632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4fc9632')) {
      api.createRecord('a4fc9632', component.options)
    } else {
      api.reload('a4fc9632', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a4fc9632&scoped=true", function () {
      api.rerender('a4fc9632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/shop-status/index.vue"
export default component.exports